type SettingsProps = {
	id: string;
	settingsConfigId: string;
	originalValue?: any;
	editedValue?: any;
};

const normalizeSettingsValue = (value: any): any => {
	if (!Array.isArray(value)) {
		return value;
	}

	return value.map((item) => {
		if (item instanceof Settings) {
			return item;
		}
		if (item && typeof item === "object" && "settings_config_id" in item) {
			return Settings.fromJson(item);
		}
		return item;
	});
};

class Settings {
	constructor(public _: SettingsProps) {}

	static fromJson(json: any): Settings {
		return new Settings({
			id: json.id,
			settingsConfigId: json.settings_config_id,
			originalValue: normalizeSettingsValue(json.value),
		});
	}

	static fromUnknown(value: Settings | Record<string, any>): Settings {
		if (value instanceof Settings) {
			return value;
		}
		if ("_" in value && value._ && typeof value._ === "object") {
			return new Settings({
				...(value._ as SettingsProps),
				originalValue: normalizeSettingsValue((value._ as SettingsProps).originalValue),
				editedValue: normalizeSettingsValue((value._ as SettingsProps).editedValue),
			});
		}
		return Settings.fromJson(value);
	}

	toJson(withEdited = false) {
		const data = {
			id: this._.id,
			settings_config_id: this._.settingsConfigId,
			value: this.value,
		} as any;
		if (withEdited) {
			data["edited"] = this.edited;
		}
		return data;
	}

	get value() {
		return this._.editedValue ?? this._.originalValue;
	}

	get edited() {
		return this._.editedValue != null && this._.editedValue !== this._.originalValue;
	}

	copyWith(props: Partial<SettingsProps>) {
		return new Settings({ ...this._, ...props });
	}
	// copyWithEdited(edited: boolean = true) {
	// 	return this.copyWith({ edited });
	// }
}

export { Settings };
